import React, { useState } from 'react';
import { Button, Input, Card } from '@/components/ui';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/core/database/supabase';
import { toast } from 'sonner';

export default function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error('Mật khẩu xác nhận không khớp');
      return;
    }

    setIsLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      toast.success('Đổi mật khẩu thành công. Vui lòng đăng nhập lại.');
      navigate('/auth/login');
    } catch (error: any) {
      toast.error('Lỗi: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 space-y-6">
        <div className="text-center space-y-2">
          <div className="w-16 h-16 bg-emerald-50 text-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <i className="ri-shield-flash-line text-3xl" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900">Thiết lập mật khẩu mới</h2>
          <p className="text-slate-500 text-sm">Vui lòng nhập mật khẩu mới và xác nhận để cập nhật bảo mật tài khoản.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Mật khẩu mới"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
          <Input
            label="Xác nhận mật khẩu"
            type="password"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="••••••••"
          />
          <Button type="submit" className="w-full" isLoading={isLoading}>
            Cập nhật mật khẩu
          </Button>
        </form>
      </Card>
    </div>
  );
}
